import { createContext } from "react";

// Define types for WebSocket message handling
export interface GenerationProgressMessage {
  type: "generation_progress";
  item_id: string;
  status: "started" | "in_progress" | "completed" | "error";
  message: string;
  progress?: number;
  version?: number;
  lang?: string;
}

export interface TranslationProgressMessage {
  type: "translation_progress";
  item_id: string;
  version: number;
  lang: string;
  status: "started" | "in_progress" | "completed" | "error";
  message: string;
}

export interface XPAwardMessage {
  type: "xp_award";
  user_id: string;
  xp_earned: number;
  activity_description: string;
  is_welcome_bonus: boolean;
  timestamp: string;
  level_up?: boolean;
  old_level?: number;
  new_level?: number;
  total_xp?: number;
  metadata?: Record<string, unknown>;
}

export interface GeneralNotificationMessage {
  type: "general_notification";
  user_id: string;
  title: string;
  message: string;
  variant: "success" | "error" | "warning" | "info";
  timestamp: string;
  metadata?: Record<string, unknown>;
}

export interface PipelineProgressMessage {
  type: "pipeline_progress";
  step: string;
  status: "started" | "in_progress" | "completed" | "error" | "running";
  message: string;
  progress?: number;
  error?: string;
  pipeline_id?: string;
  timestamp: string;
}

export interface PipelineStepInfo {
  step: string;
  display_name: string;
  status: "pending" | "started" | "in_progress" | "running" | "completed" | "error";
  progress?: number;
  message?: string;
  error?: string;
  started_at?: string;
  completed_at?: string;
}

export type WebSocketMessage =
  | GenerationProgressMessage
  | TranslationProgressMessage
  | XPAwardMessage
  | GeneralNotificationMessage
  | PipelineProgressMessage;

export interface WebSocketContextType {
  isConnected: boolean;
  lastMessage: MessageEvent | null;
  sendMessage: (message: string) => void;
  error: Event | null;
  connect: () => void;
  disconnect: () => void;
}

export const WebSocketContext = createContext<WebSocketContextType | null>(
  null,
);
